import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'

import { makeSelectSystemPreferences } from '@webapp/core/stores/global'
import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { CatalogAccessSettings } from '@webapp/modules/purchasing/entities/CatalogAccessSettings'
import { catalogAccessQueryConfig } from '@webapp/modules/purchasing/query-configs/catalogAccess'

export interface UseGetCatalogAccessSettingsModelReturn {
  data: CatalogAccessSettings | undefined
  isLoading: boolean
  error: RepoError | null
}

export const useGetCatalogAccessSettingsModel =
  (): UseGetCatalogAccessSettingsModelReturn => {
    const systemPreferences = useSelector(makeSelectSystemPreferences())

    const {
      data: catalogPermissionEnabled,
      isLoading,
      error,
    } = useQuery<boolean, RepoError>(
      catalogAccessQueryConfig.permissionEnabled()
    )

    const rfoLockDefault = systemPreferences?.rfo_lock_default ?? false

    // Guard on `error` so a failed refetch that leaves stale cached data behind
    // doesn't surface settings alongside the error state.
    const data =
      error === null && catalogPermissionEnabled !== undefined
        ? new CatalogAccessSettings({
            catalogPermissionEnabled,
            rfoLockDefault,
          })
        : undefined

    return {
      data,
      isLoading,
      error,
    }
  }
